module.exports = __webpack_public_path__ + "static/media/settings-24px.67a97c14.svg";